
import React, { Component } from 'react'
import { HashRouter, Route } from "react-router-dom";
import packageJson from './../../package.json'

// others
import ReactGA from 'react-ga';
import ScrollToTop from "./../components/ScrollToTop";

// pages
import Index from "./Index";
import Credits from "./../views/Credits.js";
import SpecialThanks from "./../views/SpecialThanks";
import About from "./../views/AboutPage";
import Development from './../views/Development';

class App extends Component {
  constructor() {
    super()
    this.state = {
      version: packageJson.version || 'ERROR', //'2020.03.27-1'
    }

    // ReactGa //------------------------------------------------------------------------------//
    ReactGA.initialize('G-N2MDDJH0H6');
    // To Report Page View 
    ReactGA.pageview(window.location.pathname + window.location.search);

    console.log("version:", this.state.version)
  }

  render() {

    return (
      <HashRouter basename="/mkdote">
        <ScrollToTop />
        <Route exact path="/" component={Index} />
        <Route path="/credits" component={Credits} />
        <Route path="/specialty" component={SpecialThanks} />
        <Route path="/about" component={About} />
        <Route path="/development" component={Development} />
      </HashRouter>
    )
  }
}

export default App;
